/**滚动条*/
<template>
  <div class="wrap">
    <div ref="box" class="box">
      <div ref="marquee" class="marquee">{{text}}</div>
    </div>
    <div ref="node" class="node" v-show="false">{{text}}</div>
  </div>
</template>
<script>
export default {
  name: "haiyaMarquee",
  data() {
    return {
        text: "" // 数组文字转化后的字符串
    };
  },
  methods: {
    move() {
      // 获取文字text 的计算后宽度  （由于overflow的存在，直接获取不到，需要独立的node计算）
      let width = this.$refs.marquee.getBoundingClientRect().width;
      console.log(width);
      let distance = this.$refs.box.getBoundingClientRect().width; // 位移距离
      // 设置位移
      setInterval(() => {
        distance = distance - 0.5;
        // 如果位移超过文字宽度，则回到起点
        if (this.$refs.box) {
          if (-distance >= width) {
            distance = this.$refs.box.getBoundingClientRect().width;
          }
          this.$refs.box.style.transform = "translateX(" + distance + "px)";
        }
      }, 20);
    }
  },
  // 把父组件传入的arr转化成字符串
  mounted() {
    this.$http.post(`${window.context.portal}/bpm/haiyaapi/getManageGreets`).then((resp) => {
        this.text = resp.data[0].zswb;
    });
    // this.move();
  },
  // 更新的时候运动
  updated() {
    this.move();
  }
};
</script>
<style scoped>
.wrap {
  overflow: hidden;
  width: 300px;
  margin: 0 auto;
}

.box {
  width: 100%;
}

.box div {
  float: left;
}

.marquee {
  margin: 0 16px 0 0;
  white-space:nowrap;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}

.node {
  position: absolute;
  z-index: -999;
  top: -999999px;
}
</style>
